/*
 * @Author: wangshengqiang
 * @Date: 2022-01-09 16:08:48
 * @LastEditTime: 2022-01-09 16:43:36
 * @LastEditors: wangshengqiang
 * @Description: 
 */
import request from '@/utils/request';
export function getQuestionnaire(data) {
  return request('/order/preUnderwriting/getQuestionnaire', {
    method: 'POST',
    data
  });
}
export function loopQuestionnaire(data) {
  return request('/order/preUnderwriting/loopQuestionnaire', {
    method: 'POST',
    data
  });
}
export function getUnderwritingResult(data) {
  return request('/order/preUnderwriting/getUnderwritingFinalResult', {
    method: 'POST',
    data
  });
}
export function saveQuestionAnswerResult(data) {
  return request('/order/preUnderwriting/saveQuestionAnswerResult', {
    method: 'POST',
    data
  });
} // MOCK

export function queryPromptPis(data) {
  return request('/order/preUnderwriting/saveQuestionAnswerResult', {
    method: 'POST',
    data
  });
}
export function queryDefaultNoticeQuestionV2(data) {
  return request('/order/preUnderwriting/saveQuestionAnswerResult', {
    method: 'POST',
    data
  });
}